import Container from '@material-ui/core/Container'
import React from 'react'

interface ContainerMaxWidthXlProps {
    /**
     * className string to be passed along to the underlying MUI `Container` component.
     */
    className?: string
}

/**
 * This is a simple container having `disableGutters` set to `true`
 * and `maxWidth` set to `xl` (1920px).
 */
const ContainerMaxWidthXl: React.FC<ContainerMaxWidthXlProps> = ({
    children,
    className,
    ...rest
}) => {
    return (
        <Container className={className} maxWidth="xl" disableGutters {...rest}>
            <>{children}</>
        </Container>
    )
}

export default ContainerMaxWidthXl
